/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { getSports } from '../../../data/sports';
import Image from '../../../Image';
// Component Commons
import SelectAttribute from '../../sections/SelectAttribute';

export default function Attributes(): JSX.Element {
    const bg = getSports().bg;

    return (
        <section className="w-full relative pt-20" role="Attributes">
            <SelectAttribute />
            <Image className="z-0" src={bg} alt="Fondo" layout="fill" objectFit="cover" objectPosition="center" />
        </section>
    );
}
